import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { useTranslation } from 'react-i18next';

import { useTariffContext } from '../../tariff.context';

export const TariffDeleteFormStep1Controller = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const tariff = useTariffContext();

  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <>
      <Text bold>
        {t('$.tariff-delete.step-1.confirm', {
          name: tariff.name,
        })}
      </Text>
      <Text italic>{t('$.tariff-delete.step-1.warning')}</Text>
    </>
  );
};
